import React from 'react';
import { Row, Col } from 'reactstrap';
import ArticleActionBar from '../ArticleActionBar/ArticleActionBar';

import './Article.css'
import ArticleMedia from '../ArticleMediaUploader/ArticleMedia';
import { history } from '../../../../../../../helpers/history';
import { lazyLoad } from '../../helpers/imageLoader.lazy';

class Article extends React.Component {
    state = {
        isExpanded: false,
        likes: 0,
        media: [],
        errorMessage: "",
        headerFile: null
    }
    componentDidMount() {
       
        this.setState({
            likes: this.props.likes
        })
        this.downloadArticleMedia(this.props.articleId, this.props.eventId);
        document.addEventListener("scroll", lazyLoad);
    }
    downloadArticleMedia = (articleId, eventId) => {

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch(`./api/files/article/${eventId}/?articleId=${articleId}`, requestOptions)
            .then(res => res.json())
            .then(files => {
                const headerFile = files.find(m => {
                    return m.url === this.props.headerImage
                });
                const newMedia = Array.from(files.filter(f => { return f.url !== this.props.headerImage }));

                this.setState({
                    mediaVm: newMedia, media: [], headerFile: headerFile
                });

            })
            .catch(err => { this.setState({ errorMessage: err }) });



    }
    expandArticle = () => {
        this.setState({ isExpanded: !this.state.isExpanded })
    }
    likeArticle = () => {
        const { articleId, eventId } = this.props;
        if (localStorage.getItem(`articleId-${articleId}`)) {
            localStorage.removeItem(`articleId-${articleId}`);
            this.setState({ likes: this.state.likes > 0 ? this.state.likes - 1 : 0 });
            const requestOptions = {
                method: "Post",
                headers: /* authHeader( */{ "Content-Type": "application/json" }/* ) */
            };
            fetch(`./api/article/like/${articleId}/?increase=false`, requestOptions)
                .then(res => {

                })
                .catch(err => console.error(err));
        }
        else {
            localStorage.setItem(`articleId-${articleId}`, true);
            this.setState({ likes: this.state.likes + 1 });
            const requestOptions = {
                method: "Post",
                headers: /* authHeader( */{ "Content-Type": "application/json" }/* ) */
            };
            fetch(`./api/article/like/${articleId}/?increase=true`, requestOptions)
                .then(res => {

                })
                .catch(err => console.error(err));

        }
    }
    isEditor = () => {
        if (localStorage.getItem("user")) {
            return true;
        }
        return false;
    }
    editArticle = () => {
        history.push('/articles/edit/' + this.props.articleId);
    }

    render() {
        const { headerImage, title, subtitle, content, articleId, publishDate, eventId, template } = this.props;
        const { isExpanded, likes, mediaVm, headerFile } = this.state;
        return (
            <div className="article-card" style={template && template.content} >
                <div className={/* !isExpanded ? "article-header" :  */"show-full"}>
                    {headerImage && headerFile && (
                        headerFile.type.includes('image') ?
                            <React.Fragment>
                                <img /* id={article.headerImage} */
                                    data-src={headerImage}
                                    data-srcset={headerImage}
                                    className="lazy blur"
                                    src={"https://images.iphonephotographyschool.com/22686/1120b/How-To-Blur-Background-On-iPhone.jpg"} />
                              {/*   <div className="lazy">
                                    <Spinner color="info" />
                                </div> */}
                            </React.Fragment>


                            :
                            <video controls /* loop */ autoPlay/* src={article.headerImage} */ >
                                <source src={headerImage} type="video/mp4" />
                                <source src={headerImage} type="video/quicktime" />
                            </video>
                    )}
                </div>
             {/*    <br/> */}
                <div >
                    <Col>
                        <div className="article-title">
                            <h1 style={template && template.title}>{title}</h1>
                        </div>
                        <div>
                            <h4 style={template && template.subtitle}>{subtitle}</h4>
                        </div>
                        <div className={!isExpanded ? 'text-body-collapsed wrap' : 'text-body-show wrap'}>
                            <section>
                                <p style={template && template.text}>
                                    {content}
                                    {/*         {!isExpanded && <p className="fadeout"></p>} */}
                                </p>

                                <ArticleMedia headerImage={headerImage} media={mediaVm} editMode={false} />
                                {this.state.errorMessage != "" && this.state.errorMessage}
                                {/*         <p className="text-muted">Publicerades {publishDate}</p> */}

                            </section>
                            <section>

                            </section>
                        </div>
                        <Row>
                            <ArticleActionBar
                                expandArticle={this.expandArticle}
                                likeArticle={this.likeArticle}
                                articleId={articleId}
                                likes={likes}
                                isExpanded={isExpanded}
                                buttonStyle={template}
                                isEditor={this.props.isEditable}
                                edit={this.editArticle}
                                isLiked={localStorage.getItem(`articleId-${articleId}`) !== null} />
                        </Row>

                    </Col>
                </div>
            </div>

        )
    }
}
export default Article;


